import { environment } from '../environments/environment';

export const gainsightTagKey = environment.production
  ? 'AP-6W0LJVPRGHBU-2'
  : 'AP-6W0LJVPRGHBU-2-3';

const appConfig = {
  oidc: {
    clientId: environment.oktaClientId,
    issuer: environment.oktaIssuer,
    redirectUri: `${environment.siteUrl}/login/callback`,
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
  },
  gainsightTagKey,
};

export default appConfig;
